import { h } from '@stencil/core';

const TrashIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.81486 4.81481L5.96785 14.0388C6.15551 15.5401 7.43171 16.6667 8.94468 16.6667L11.0554 16.6667C12.5684 16.6667 13.8446 15.5401 14.0322 14.0388L15.1852 4.81481M4.81486 4.81481L3.33337 4.81481M4.81486 4.81481L8.14819 4.81481M15.1852 4.81481L16.6667 4.81481M15.1852 4.81481L11.8519 4.81481M8.14819 4.81481L10 4.81481L11.8519 4.81481M8.14819 4.81481L11.8519 4.81481M8.14819 4.81481L8.14819 3.33333L11.8519 3.33333L11.8519 4.81481M10 6.66666L10 14.4444" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}

export default TrashIcon;
